import { PermissionTypes } from 'institutions/services/roles-service';
import { RoleResourceType } from 'redux/schemas/models/role';

export default {
  bindings: {
    headerText: '@?',
    onRoleChanged: '&?',
    learnersOnly: '=',
    adminsOnly: '=',
    initialRole: '<?',
  },
  controllerAs: 'vm',
  controller: function ctrl($scope, $state, _, $translate, InstitutionsManager, CourseRolesManager, RolesService,
    CurrentCourseManager, config) {
'ngInject';
    const vm = this;
    vm.CourseRolesManager = CourseRolesManager;
    vm.CurrentCourseManager = CurrentCourseManager;
    vm.courseRoles = Object.values(CourseRolesManager.roles).filter((role) => role.resourceType === RoleResourceType.COURSE);
    vm.popoverRoleId = null;
    vm.config = config;
    vm.rolesPermissionsArticlelink = `${vm.config.helpLink}/article/ART-1586`;

    vm.learnerRoles = [
      vm.CourseRolesManager.noRolesRole,
    ];
    vm.adminOnlyRoles = [];
    vm.adminAndMentorRoles = [];
    vm.mentorOnlyRoles = [];

    vm.isJourney = CurrentCourseManager.course.isJourney;

    const allowedRolesInJourney = [
      PermissionTypes.CONFIGURATION_REGISTRATION,
      PermissionTypes.INSTRUCTOR,
      PermissionTypes.TEACHER_ASSISTANT,
      PermissionTypes.COURSE_BUILDER,
      PermissionTypes.REPORT_ADMIN,
      PermissionTypes.LEARNER_REGISTRATION,
    ];

    vm.getAliases = () => ({
      ...CurrentCourseManager.course.getAliases(),
      isJourney: vm.isJourney,
    });

    if (!vm.adminsOnly) {
      vm.learnerRoles = vm.learnerRoles.concat(vm.courseRoles.filter((r) => RolesService.hasPermission(r.permission, PermissionTypes.CUSTOM_ROLE)));
    }

    if (!vm.learnersOnly) {
      vm.adminOnlyRoles = vm.courseRoles.filter((r) => {
        const journeyAllowed = vm.isJourney ? (
          allowedRolesInJourney.some((permission) => RolesService.hasPermission(r.permission, permission))
        ) : true;

        // If we are hiding mentor categories, we need to include mentors in admin only category as well.
        const includeMentors = !RolesService.isMentor(r);

        return r.permission > PermissionTypes.CUSTOM_ROLE && includeMentors && journeyAllowed;
      });

      vm.adminAndMentorRoles = vm.courseRoles.filter((r) => r.permission > PermissionTypes.CUSTOM_ROLE
          && RolesService.isMentor(r) && r.permission !== PermissionTypes.ADVISOR);
      // Mentors are considered 'admins' for the purpose of this filtering
      vm.mentorOnlyRoles = vm.courseRoles.filter((r) => r.permission === PermissionTypes.ADVISOR);
    }

    if (vm.initialRole) {
      vm.selectedRoleId = vm.initialRole.id;
    }

    vm.onRoleSelected = (roleId) => {
      vm.selectedRoleId = roleId;

      if (vm.onRoleChanged) {
        let role = null;
        if (roleId === vm.CourseRolesManager.noRolesRole.id) {
          role = vm.CourseRolesManager.noRolesRole;
        } else {
          role = Object.values(vm.CourseRolesManager.roles).find((roleObj) => roleObj.id === roleId);
        }

        vm.onRoleChanged()(role);
      }
    };

    // TODO: this doesn't seem to be used anywhere. Look into removing it.
    vm.categoryHasInitRole = (category) => vm.selectedRoleId >= 0 && category.some((roleModel) => roleModel.id === vm.selectedRoleId);

    vm.categoryOpen = {
      'USER_MANAGEMENT.LEARNER_ROLES': true,
    };

    vm.selectCategory = (title) => {
      if (title) {
        if (vm.categoryOpen[title]) {
          delete vm.categoryOpen[title];
        } else {
          vm.categoryOpen = {
            [title]: true,
          };
        }
      }
    };

    this.$onChanges = function (changes) {
      if (changes.initialRole?.currentValue?.id === 0) {
        // Resetting to initialRole
        vm.selectedRoleId = changes.initialRole.currentValue.id;
        vm.categoryOpen['USER_MANAGEMENT.LEARNER_ROLES'] = true;
      }
    };

    return vm;
  },
  templateUrl: 'user_management/templates/nv-roles-radio.html',
};
